import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CurrentAddress, Device } from '../appTypings';
import { State } from '../configureStore';
import usePromiseWithErrorHandling from './usePromiseWithErrorHandling';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';

export const getInfoEntries = (
  device: Device | undefined,
  currentAddress: CurrentAddress,
  version: string
) => {
  const enabledKeys = [
    'vendor',
    'model',
    'application version',
    'version',
    'software',
    'useragent',
  ];
  const versionInfo = { 'application version': version };
  const userAgent = { useragent: window.navigator.userAgent };

  return version === 'dev'
    ? Object.entries({
        ...device,
        ...currentAddress,
        ...versionInfo,
        ...userAgent,
      })
    : Object.entries({ ...device, ...versionInfo, ...userAgent }).filter(
        ([key, value]) => value?.length && enabledKeys.includes(key)
      );
};

export const useInformation = () => {
  const [version, setVersion] = useState('');
  const { device } = useAppFeaturesContext();
  const currentAddress = useSelector((state: State) => state.currentAddress);

  const infoEntries = useMemo(() => {
    return getInfoEntries(device, currentAddress, version);
  }, [device, currentAddress, version]);

  const { run: getVersion } = usePromiseWithErrorHandling(async function () {
    const response = await (await fetch('/version')).json();
    setVersion(response.version);
  });

  useEffect(() => {
    getVersion();
  });

  return {
    infoEntries,
  };
};
